import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Stack,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  FormControlLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getCIDS } from "../services/cidService";
import { updateUserPermissions } from "../services/permissionsService";

// Per-CID role: none (no access) | read (view only) | write (view + edit).
const roleForCid = (cidId, permissions, writePermissions) => {
  if (writePermissions.includes(cidId)) {
    return "write";
  }
  if (permissions.includes(cidId)) {
    return "read";
  }
  return "none";
};

const EditUser = (props) => {
  const [admin, setAdmin] = useState(false);
  const [cids, setCIDS] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [writePermissions, setWritePermissions] = useState([]);

  const handleClose = () => {
    props.handleClose(!props.dialogOpen);
  };

  useEffect(() => {
    async function init() {
      const res = await getCIDS();
      setCIDS(res);
    }
    init();
    if (props.user) {
      setPermissions(props.user.permissions || []);
      setWritePermissions(props.user.write_permissions || []);
      setAdmin(props.user.admin);
    }
  }, [props.user]);

  const setRole = (cidId, role) => {
    const without = (list) => list.filter((id) => id !== cidId);
    if (role === "write") {
      setPermissions((prev) => [...without(prev), cidId]);
      setWritePermissions((prev) => [...without(prev), cidId]);
    } else if (role === "read") {
      setPermissions((prev) => [...without(prev), cidId]);
      setWritePermissions((prev) => without(prev));
    } else {
      setPermissions((prev) => without(prev));
      setWritePermissions((prev) => without(prev));
    }
  };

  return (
    <Dialog
      fullWidth
      open={props.dialogOpen ? true : false}
      onClose={handleClose}
    >
      <DialogTitle>
        Edit {props.user ? props.user.name + "'s" : ""} CID Permissions
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Read = view the CID's data. Read &amp; Write = also add, edit,
          import, and delete. Users with write access to at least one CID can
          edit contacts (contacts are shared across CIDs).
        </Typography>
        <Stack spacing={1.5}>
          {cids && props.user
            ? cids.map((c) => (
                <Stack
                  key={c.id}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Typography variant="body1">{c.name}</Typography>
                  <ToggleButtonGroup
                    exclusive
                    size="small"
                    color="primary"
                    disabled={Boolean(admin)}
                    value={
                      admin
                        ? "write"
                        : roleForCid(c.id, permissions, writePermissions)
                    }
                    onChange={(e, role) => role && setRole(c.id, role)}
                  >
                    <ToggleButton value="none">None</ToggleButton>
                    <ToggleButton value="read">Read</ToggleButton>
                    <ToggleButton value="write">Read &amp; Write</ToggleButton>
                  </ToggleButtonGroup>
                </Stack>
              ))
            : null}
          <FormControlLabel
            label="Admin (full access to every CID and settings)"
            control={
              <Switch checked={Boolean(admin)} onChange={() => setAdmin(!admin)} />
            }
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={() => handleClose()}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="warning"
          onClick={() => {
            updateUserPermissions({
              permissions: permissions,
              writePermissions: writePermissions,
              admin: admin,
              email: props.user ? props.user.email : null,
            });
            handleClose();
          }}
        >
          Update User
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUser;
